import { useState } from "react";
import { useNavigate } from "react-router-dom";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import authApi from "../../api/authApi";
import { getLabel } from "../../tools/Dictionary";

import "./Auth.css";
import logo from "../../images/Innovair_logo.png";

const AuthForgot = (props) => {

  //Navigation
  const Navigate = useNavigate();

  //Props
  //const IsDesktop = props.IsDesktop;

  //State
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  //Password Input
  const onChangeEmail = (e) =>
  {

    let email = e.target.value;


    setEmail(email);

  };


  const onClickSubmit = async () =>
  {

    if (!email || email === "")
    {
      setAlert({
        Title: getLabel("App", "Error"),
        Message: getLabel("AuthForgot", "Please enter your email address."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });
      return;
    }

    try
    {

      setLoading(true);

      let response = await authApi.forgotPassword({email});

      if (response.Error)
      {

        throw new Error(response.Error.component ? getLabel(response.Error.component, response.Error.label) : response.Error.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."));

      }

      

      setAlert({
        Title: getLabel("AuthForgot", "Link on its way!"),
        Message: getLabel("AuthForgot", "An email with password-reset instructions is on its way. Check your inbox and your junk folder, then click the link within 1 hour to pick a new password."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: onClickCancel,
        Display: true
      });



    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      setLoading(false);

    }

  }

  const onClickCancel = () =>
  {

    Navigate("/");

  }


  return (
    <div className="auth_page_cont">
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <div className="auth_page_title">
        <img src={logo} alt="logo" style={{ width: "50%" }} />
      </div>
      <div className="auth_cont">
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
          isCover={true}
        />
        <div className="auth_cont_title">
          {getLabel("AuthForgot", "Forgotten password")}
        </div>
        <div className="auth_cont_body">
          <div className="auth_forgot_text">
            {getLabel("AuthForgot", "Enter the email address associated with your Innovair Solutions account...")}
          </div>
          <input
            className={"form-control auth_cont_login_input"}
            type="text"
            placeholder={getLabel("AuthForgot", "Email")}
            value={email}
            onChange={onChangeEmail}
            disabled={loading}
            autoFocus
          />
        </div>
        <div className="auth_fill_footer" style={{ marginTop: "10px" }}>
          <input
            type="button"
            className="page_button auth_cont_login_button"
            value={getLabel("AuthForgot", "Send reset link")}
            onClick={onClickSubmit}
            disabled={loading}
          />
          <input
            type="button"
            className="page_button auth_cont_cancel_button"
            style={{ backgroundColor: "#424242" }}
            value={getLabel("AuthSignup", "Cancel")}
            onClick={onClickCancel}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

};

export default AuthForgot